// extracted by mini-css-extract-plugin
export default {"welcome-wrapper":"default_welcome-wrapper__BnWLI"};